import React from "react";
import GetCategories from "./GetCategories";
import GetProgramInfo from "./GetProgramInfo";
import GetPreferences from "./GetPreferences";
import GetFavorites from "./GetFavorites";
import GetStoreMappings from "./GetStoreMappings";
import CheckForSession from "./CheckForSession";
import GetIP from "./GetIP";

export default ({ children }) => (
  <GetProgramInfo>
    <CheckForSession>
      <GetStoreMappings></GetStoreMappings>
      <GetIP>
        <GetPreferences>
          <GetCategories>
            <GetFavorites>{children}</GetFavorites>
          </GetCategories>
        </GetPreferences>
      </GetIP>
    </CheckForSession>
  </GetProgramInfo>
);
